// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel__CMuCe","headingContainer":"styles_headingContainer__gcVQc","contentContainer":"styles_contentContainer__jn3Kz"};